export enum CartValidationErrors {
  ALL_LINE_ITEMS_UNSELECTED = "ALL_LINE_ITEMS_UNSELECTED",
}
